const theme = {
  colors: {
    // Primary colors
    primary: '#1e3a6e', // Dark navy blue for header
    secondary: '#2b5db8', // Accent blue
    tertiary: '#3672d9', // Lighter blue for highlights
    
    // Background colors
    background: {
      main: '#1c1f26', // Dark background
      paper: '#24283b', // Slightly lighter for content areas
      input: '#2c2f3d', // For input fields
    },
    
    // Text colors
    text: {
      primary: '#ffffff',
      secondary: '#a9b8d3',
      tertiary: '#7187ad',
      disabled: '#5d6b82',
    },
    
    // Status colors
    status: {
      correct: '#4caf50',
      incorrect: '#e53935',
      neutral: '#64748b',
      warning: '#ff9800',
    },
    
    // Borders and dividers
    border: {
      light: '#404756',
      medium: '#2c3042',
      dark: '#1a1d29',
    },
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
  },
  
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    rounded: '50%',
  },
  
  shadows: {
    small: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    medium: '0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)',
    large: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
  },
  
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },

  transitions: {
    fast: '150ms ease',
    normal: '300ms ease',
    slow: '500ms ease',
  },
};

export default theme; 